module.exports = __webpack_public_path__ + "media/pages/assets/images/gallery/2021/february-62b5e5979f8d96f20aa347416c7f2885.png";